(() => {
  'use strict';
  const host = document.getElementById('seal-review-widget');
  const configNode = document.getElementById('ld-reviews-data');
  if (!host || !configNode || host.dataset.ready) return;
  host.dataset.ready = 'true';
  const config = JSON.parse(configNode.textContent);
  const widget = host.querySelector('#vstar-reviews');
  const list = host.querySelector('.tt-review-list');
  const footer = host.querySelector('#reviews-footer');
  const status = host.querySelector('[data-reviews-status]');
  const sortPopup = host.querySelector('.sort-popup');
  const sortIcon = host.querySelector('.sort-icon');
  const dialog = host.querySelector('dialog');
  const normalizeBrand = value => String(value ?? '').replace(/les\s*dormeurs(?:®)?/gi, 'maisonsleep®');
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const mediaURL = value => {
    try { const u = new URL(value); return u.protocol === 'https:' ? u.href : ''; } catch { return ''; }
  };
  // Customer-requested corrections on this storefront survive source refreshes.
  const corrections = config.corrections || {};
  function correctedReview(review) {
    const correction = corrections[String(review.id)];
    return correction ? { ...review, star: correction.review.star, content: correction.review.content } : review;
  }
  config.reviews = config.reviews.map(correctedReview);
  config.album = config.album.map(correctedReview);
  function correctedPage(data, page) {
    let rows = data.list.map(correctedReview);
    const prepend = [], append = [];
    for (const [id, correction] of Object.entries(corrections)) {
      const review = correction.review;
      if (Number(correction.fromStar) === Number(review.star)) continue;
      if (state.rating) {
        // Move the corrected review into its new rating group exactly once.
        rows = rows.filter(row => String(row.id) !== id);
        if (page === 1 && Number(review.star) === state.rating) prepend.push(review);
      } else if (Number(review.star) === 5 && state.sort.startsWith('rating-')) {
        rows = rows.filter(row => String(row.id) !== id);
        if (state.sort === 'rating-descending' && page === 1) prepend.push(review);
        if (state.sort === 'rating-ascending' && page === Number(data.page.total_page)) append.push(review);
      }
    }
    if (state.rating) rows = rows.filter(review => Number(review.star) === state.rating);
    return [...prepend, ...rows, ...append];
  }
  const state = { page: 1, total: config.totalPages, sort: 'comprehensive-descending', rating: 0, rows: config.reviews, request: 0, controller: null };
  const cache = new Map([['comprehensive-descending:0:1', { list: config.reviews, page: { cur_page: 1, total_page: config.totalPages } }]]);
  const relative = new Intl.RelativeTimeFormat('de', { numeric: 'auto' });
  function age(value) {
    const time = Date.parse(String(value).replace(' ', 'T') + 'Z');
    if (!Number.isFinite(time)) return '';
    const days = Math.max(0, Math.floor((Date.now() - time) / 86400000));
    if (days >= 365) return relative.format(-Math.floor(days / 365), 'year');
    if (days >= 30) return relative.format(-Math.floor(days / 30), 'month');
    return relative.format(-days, 'day');
  }
  function stars(rating) {
    return `<div class="vstar-star" role="img" aria-label="${escape(rating)} von 5">${Array.from({ length: 5 }, (_, i) => `<div class="star-item${i >= rating ? ' nostar' : ''}">${config.starSVG}</div>`).join('')}</div>`;
  }
  function row(review, index) {
    const author = String(review.author || '').trim();
    const verified = true; // All purchases confirmed by the source merchant via the store owner.
    const resources = (review.resources || []).map((resource, resourceIndex) => {
      const src = mediaURL(resource.thumb_src || resource.src);
      return src ? `<button type="button" class="resource-item" data-photo-review="${index}" data-photo-index="${resourceIndex}" aria-label="Foto vergrößern: ${escape(author)}"><img loading="lazy" src="${escape(src)}" alt="Bettdeckenfoto von ${escape(author)}"></button>` : '';
    }).join('');
    return `<article class="list-review split" data-rating="${Number(review.star)}" review-id="${escape(review.id)}">
      <div class="list-review-head"><div class="user-message"><div class="tt-review-avatar" translate="no">${escape(author.charAt(0).toUpperCase())}${verified ? config.badgeSVG : ''}</div><div><span class="user-name"><span class="author-name">${escape(author)}</span></span><div class="user-verified"><span class="verified-text" data-tt-lang-path="verified_purchase">Verifizierter Kauf</span></div></div></div><time class="reviews-date" datetime="${escape(String(review.commented_at).replace(' ', 'T'))}">${escape(age(review.commented_at))}</time></div>
      <div class="list-review-body">${stars(Number(review.star))}${review.title ? `<div class="tt-review-title">${escape(normalizeBrand(review.title))}</div>` : ''}<p class="reviews-text">${escape(normalizeBrand(review.content))}</p>${resources ? `<div class="resource-list">${resources}</div>` : ''}${review.reply_content ? `<div class="merchant-reply"><div class="ld-review-merchant">maisonsleep®</div><div class="reply-content">${escape(normalizeBrand(review.reply_content))}</div></div>` : ''}</div></article>`;
  }
  function pagination() {
    if (state.total <= 1) { footer.innerHTML = ''; return; }
    let start = Math.max(1, state.page - 2);
    start = Math.max(1, Math.min(start, state.total - 4));
    const items = [];
    const pageButton = (number, label, extra = '') => `<li><button type="button" class="${extra || 'page-control-item'}${number === state.page ? ' active' : ''}" data-page="${number}" aria-label="Seite ${number}" ${number === state.page ? 'aria-current="page"' : ''}>${label}</button></li>`;
    if (state.page > 1) items.push(pageButton(state.page - 1, '‹', 'page-control-button pre-page'));
    for (let i = start; i <= Math.min(state.total, start + 4); i++) items.push(pageButton(i, i));
    if (state.page < state.total) items.push(pageButton(state.page + 1, '›', 'page-control-button next-page'));
    footer.innerHTML = `<nav aria-label="Seiten der Kundenbewertungen"><ul class="page-control" style="display:flex">${items.join('')}</ul></nav>`;
  }
  function refreshControls() {
    host.querySelectorAll('.sort-item').forEach(item => {
      const selected = item.getAttribute('sort-value') === state.sort;
      item.classList.toggle('active', selected);
      item.setAttribute('aria-selected', String(selected));
    });
    const activeSort = host.querySelector('.sort-active');
    const selectedIndex = Array.from(host.querySelectorAll('.sort-item')).findIndex(item => item.classList.contains('active'));
    if (activeSort) activeSort.style.top = `${54 + selectedIndex * 35}px`;
    host.querySelectorAll('.star-raw').forEach(item => item.setAttribute('aria-pressed', String(Number(item.dataset.ratingFilter) === state.rating)));
    host.querySelector('[data-clear-rating]').hidden = !state.rating;
    pagination();
  }
  async function load(page = 1) {
    const request = ++state.request;
    state.controller?.abort();
    state.controller = new AbortController();
    const key = `${state.sort}:${state.rating}:${page}`;
    let data = cache.get(key);
    widget.setAttribute('aria-busy', 'true');
    status.textContent = 'Bewertungen werden geladen…';
    const timeout = setTimeout(() => state.request === request && state.controller.abort(), 15000);
    try {
      if (!data) {
        const params = new URLSearchParams({ shop_id: config.shopId, product_id: config.sourceProductId || config.productId, page, limit: 15, sort_by: state.sort, lang: 'de', no_empty: 2 });
        if (state.rating) params.set('rating_filter', state.rating);
        const response = await fetch(`https://api.trustoo.io/api/v1/reviews/get_product_reviews?${params}`, { signal: state.controller.signal, credentials: 'omit' });
        if (!response.ok) throw new Error('HTTP ' + response.status);
        const result = await response.json();
        if (result.code !== 0 || !Array.isArray(result.data?.list) || !result.data.page) throw new Error('Invalid reviews response');
        data = result.data;
        cache.set(key, data);
      }
      if (request !== state.request) return;
      state.page = page;
      state.total = Math.max(1, Number(data.page.total_page) || 1);
      state.rows = correctedPage(data, page);
      list.innerHTML = state.rows.length ? state.rows.map(row).join('') : '<p class="ld-reviews-empty">Für diese Bewertung gibt es keine Rezensionen.</p>';
      refreshControls();
      status.textContent = '';
      list.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (error) {
      if (request === state.request) {
        status.textContent = 'Weitere Bewertungen sind vorübergehend nicht verfügbar. Bitte versuche es gleich noch einmal.';
      }
    } finally {
      clearTimeout(timeout);
      if (request === state.request) widget.removeAttribute('aria-busy');
    }
  }
  function closeSort() { sortPopup.style.display = 'none'; sortIcon.setAttribute('aria-expanded', 'false'); }
  let photoItems = [], photoPosition = 0;
  function openPhoto(review, resourceIndex, trigger, items) {
    if (items) {
      photoItems = items.flatMap(r => (r.resources || []).map((media, index) => ({ review:r, index })));
      photoPosition = Math.max(0, photoItems.findIndex(item => String(item.review.id) === String(review.id) && item.index === resourceIndex));
    }
    const media = review?.resources?.[resourceIndex];
    if (!media) return;
    const image = dialog.querySelector('img');
    image.src = mediaURL(media.src || media.thumb_src);
    image.alt = `Bettdeckenfoto von ${String(review.author || '').trim()}`;
    dialog.querySelector('[data-photo-author]').textContent = review.author;
    dialog.querySelector('[data-photo-stars]').innerHTML = stars(Number(review.star));
    dialog.querySelector('[data-photo-text]').textContent = normalizeBrand(review.content);
    dialog.querySelector('[data-photo-date]').textContent = age(review.commented_at);
    dialog.querySelector('[data-photo-prev]').hidden = photoPosition <= 0;
    dialog.querySelector('[data-photo-next]').hidden = photoPosition >= photoItems.length - 1;
    if (!dialog.open) { dialog._trigger = trigger; dialog.showModal(); }
    document.documentElement.classList.add('ld-review-photo-open');
  }
  host.addEventListener('click', event => {
    const target = event.target;
    const page = target.closest('#reviews-footer [data-page]');
    if (page) { load(Number(page.dataset.page)); return; }
    const sort = target.closest('.sort-item');
    if (sort) { state.sort = sort.getAttribute('sort-value'); closeSort(); load(); return; }
    if (target.closest('.sort-icon')) {
      const open = sortPopup.style.display === 'block';
      sortPopup.style.display = open ? 'none' : 'block';
      sortIcon.setAttribute('aria-expanded', String(!open)); return;
    }
    const filter = target.closest('[data-rating-filter]');
    if (filter) { state.rating = state.rating === Number(filter.dataset.ratingFilter) ? 0 : Number(filter.dataset.ratingFilter); load(); return; }
    if (target.closest('[data-clear-rating]')) { state.rating = 0; load(); return; }
    const photo = target.closest('[data-photo-review]');
    if (photo) { openPhoto(state.rows[Number(photo.dataset.photoReview)], Number(photo.dataset.photoIndex), photo, state.rows); return; }
    const album = target.closest('[data-album-index]');
    if (album) { openPhoto(config.album[Number(album.dataset.albumIndex)], 0, album, config.album); return; }
    if (target.closest('[data-photo-prev],[data-photo-next]')) {
      photoPosition += target.closest('[data-photo-next]') ? 1 : -1;
      photoPosition = Math.max(0, Math.min(photoItems.length - 1, photoPosition));
      const item = photoItems[photoPosition];
      if (item) openPhoto(item.review, item.index, dialog._trigger);
      return;
    }
    if (target.closest('[data-close-photo]') || target === dialog) dialog.close();
    if (target.closest('.tt-write-reviews')) window.open(config.sourceURL + '#seal-review-widget', '_blank', 'noopener,noreferrer');
  });
  document.addEventListener('click', event => { if (!event.target.closest('.head-sort')) closeSort(); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeSort(); });
  host.addEventListener('keydown', event => {
    if (['Enter', ' '].includes(event.key) && event.target.matches('[role="button"],.sort-item')) { event.preventDefault(); event.target.click(); }
  });
  dialog.addEventListener('close', () => { document.documentElement.classList.remove('ld-review-photo-open'); dialog._trigger?.focus({preventScroll:true}); });
  const rate = document.querySelector('.cfb-rate');
  if (rate) {
    const count = rate.querySelector('.cfb-rn');
    if (count) count.innerHTML = `<b>${config.rating.toFixed(1).replace('.', ',')}</b> (${config.count})`;
    rate.setAttribute('aria-label', `Bewertung mit ${config.rating.toFixed(1).replace('.', ',')} von 5 — ${config.count} Bewertungen zur Bettdecke von maisonsleep®. Bewertungen am Ende der Seite ansehen`);
  }
  refreshControls();
})();
